import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

gsap.to(".main-nav:not(.sticky)", {
  "--main-nav-background-opacity": 1,
  scrollTrigger: {
    trigger: ".main-nav",
    start: "top top",
    end: "+=100",
    scrub: true,
    toggleActions: "play none none reverse",
    markers: false,
  }
});